import React from "react";
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { useTheme } from '../context/ThemeContext';
import '../styles/Logo.css';

const Logo = ({ showAuthButtons = false }) => {
  const logo = require('../logo.jpeg');
  const { isLoggedIn, logout } = useAuth();
  const { isDark, toggleTheme } = useTheme();
  const navigate = useNavigate();

  const handleLogout = () => {
    logout();
    navigate('/');
  };

  return (
    <nav className="navbar">
      <div className="navbar-inner">
        <Link to="/" className="navbar-brand-link">
          <div className="navbar-brand">
            <img src={logo} className="navbar-logo" alt="Menu & Catalog Maker logo" />
            <span className="navbar-title">Menu &amp; Catalog Maker</span>
          </div>
        </Link>

        <div className="navbar-right">
        <button
          className="navbar-theme-toggle"
          onClick={toggleTheme}
          aria-label={isDark ? 'Switch to light mode' : 'Switch to dark mode'}
          title={isDark ? 'Light mode' : 'Dark mode'}
        >
          {isDark ? (
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <circle cx="12" cy="12" r="5" />
              <line x1="12" y1="1" x2="12" y2="3" />
              <line x1="12" y1="21" x2="12" y2="23" />
              <line x1="4.22" y1="4.22" x2="5.64" y2="5.64" />
              <line x1="18.36" y1="18.36" x2="19.78" y2="19.78" />
              <line x1="1" y1="12" x2="3" y2="12" />
              <line x1="21" y1="12" x2="23" y2="12" />
              <line x1="4.22" y1="19.78" x2="5.64" y2="18.36" />
              <line x1="18.36" y1="5.64" x2="19.78" y2="4.22" />
            </svg>
          ) : (
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <path d="M21 12.79A9 9 0 1 1 11.21 3 7 7 0 0 0 21 12.79z" />
            </svg>
          )}
        </button>

        {showAuthButtons ? (
          isLoggedIn ? (
            <div className="navbar-auth-group">
              <Link to="/manage" className="navbar-auth-dashboard">
                Dashboard
              </Link>
              <button className="navbar-auth-logout" onClick={handleLogout}>
                Log out
              </button>
            </div>
          ) : (
            <div className="navbar-auth-group">
              <Link to="/login" className="navbar-auth-login">
                Log in
              </Link>
              <Link to="/login" state={{ tab: 'signup' }} className="navbar-auth-signup">
                Sign up
              </Link>
            </div>
          )
        ) : (
          <a
            href="https://play.google.com/store/apps/details?id=com.aguslc.monbusiness"
            target="_blank"
            rel="noopener noreferrer"
            className="navbar-cta"
          >
            Download Free
          </a>
        )}
        </div>
      </div>
    </nav>
  );
};

export default Logo;
